export * from '@fhs/routing/src/routes/store-locator/service-mode';
export { default } from '@fhs/routing/src/routes/store-locator/service-mode';
